"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _index = _interopRequireDefault(require("./index"));
var _TextBase = _interopRequireDefault(require("./TextBase"));
var _excluded = ["className"];
var defaultStyle = require("./../empty_css.js")["default"];
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var className = _ref.className,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_index["default"], Object.assign({}, props, {
    className: (0, _clsx["default"])((props.classNames || defaultStyle).textComponent, className),
    ref: ref,
    InputComponent: _TextBase["default"]
  }));
});